import { connect } from 'react-redux';
import { guestActions, alertActions } from '../../actions';
import GuestItem from '../../components/forms/GuestItem';

const mapDispatchToProps = (dispatch) => {
  return {
    removeGuest: (guest) => {
      dispatch(guestActions.removeGuest(guest));
    },
    clearAlert: () => {
      dispatch(alertActions.clear());
    }
  }
}

export default connect(null, mapDispatchToProps)(GuestItem)
